import { WidgetOption } from '../types'

import unknown from './unknown'

/** 签署 */
import seal from './seal'
import signature from './signature'
import date from './date-sign'
import remark from './remark'

/** 文本填写 */
import input from './input'
import textarea from './textarea'
import number from './number'
import id from './id'
import dateFill from './date-fill'

/** 选择 */
import checkbox from './checkbox'
import radioGroup from './radio-group'
import checkboxGroup from './checkbox-group'
import select from './select'

import attachment from './attachment'
import image from './image'
import table from './table'

/** 控件列表 */
export const widgetOptions: WidgetOption[] = [
  unknown,
  signature,
  seal,
  date,
  remark,
  input,
  textarea,
  checkbox,
  image,
  attachment,
  number,
  id,
  dateFill,
  radioGroup,
  checkboxGroup,
  select,
  table
]
